// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import Address from "./types/address";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class CrossContractInitialize extends PerunMessage {
  @jsonMember(Address) ethClientAddress: Address;
  @jsonMember(String) steClientAddress: string;
  @jsonMember(Boolean) egoisticClient = true;
  @jsonMember(String) l2Account = "";

  constructor(EthClientAddress: Address, SteClientAddress: string, l2Account?: string) {
    super();
    this.ethClientAddress = EthClientAddress;
    this.steClientAddress = SteClientAddress;
    if (l2Account) {
      this.l2Account = l2Account;
    }
  }

  messageType(): MessageType {
    return CrossContractInitialize;
  }

  messageTypeName(): MessageTypeName {
    return "CrossContractInitialize";
  }
}
